import { Pagination } from '../types';

export const getPaginatedResult = <T>(result: T[], pagination: Pagination) => {
  const start = (pagination.start - 1) * pagination.perPage; // pagination start always begins with 1, need to convert to 0 to match the array index
  const end = start + pagination.perPage;

  return result.slice(start, end);
};
